import { createClass as _createClass } from "\0rollupPluginModLoBabelHelpers.js";
import { defineProperty as _defineProperty } from "\0rollupPluginModLoBabelHelpers.js";

var _class, _class2, _temp;

import { cclegacy as _cclegacy } from "cc";

_cclegacy._RF.push({}, "0e5d2OEJIpJRKE+1gtx/F2k", "AdCocos", undefined);

import AdEvent from "../AdEvent";
import { E_ADEventType } from "../../EnumBase";
import { _decorator } from "cc";
var ccclass = _decorator.ccclass;

var AdCocos = ccclass(_class = (_temp = _class2 = /*#__PURE__*/function () {
  function AdCocos() {
    _defineProperty(this, "_gameId", 660862835);

    _defineProperty(this, "_bannerId", "825670941");

    _defineProperty(this, "_interstitialId", "57498326");

    _defineProperty(this, "_videoId", "760985143");

    _defineProperty(this, "_banner", {});

    _defineProperty(this, "_interstitialAd", {});

    _defineProperty(this, "_videoAd", {});

    _defineProperty(this, "_bannerLoadTimes", 0);

    _defineProperty(this, "bannerLoaded", false);

    _defineProperty(this, "_interstitialLoadTimes", 0);

    _defineProperty(this, "interstitialAdLoaded", false);

    _defineProperty(this, "_videoLoadTimes", 0);

    _defineProperty(this, "videoAdLoaded", false);

    _defineProperty(this, "_isVideoPlayed", false);

    _defineProperty(this, "isBannering", false);
  }

  var _proto = AdCocos.prototype;

  _proto.firstLoad = function firstLoad() {
    this.createBannerAd();
    this.createInterstitialAd();
    this.createRewardedVideoAd();
  };

  _proto.init = function init() {
    //设置初始化回调函数
    window["GameSDK"].setOnInitCB(this.onInit); //设置平台进入前台回调函数
    // window["GameSDK"].setOnResumeCB(this.onResume);
    // //设置平台进入后台回调函数
    // window["GameSDK"].setOnPauseCB(this.onPause);
    // //设置平台声音控制回调函数
    // window["GameSDK"].setOnAudioCB(this.onAudio);
    // //设置支付回调函数
    // window["GameSDK"].setOnPayCB(this.onPay);
    //初始化GameSDK

    window["GameSDK"].init(this._gameId); //初始化AdSDK,依赖GameSDK

    window["AdSDK"].init();
    this.firstLoad();
  } //平台收到游戏init初始化后，会通过该函数回传用户信息
  //    error,  // int 错误代码：0、成功（见文末）
  //    userId,  // int当前玩家id
  //    nickName,  // string当前玩家名称
  //    headUrl,  // string 当前玩家头像地址
  //    location,  //string当前玩家地址
  //    sex,  // string 玩家性别："f" - 女；"m" - 男；"x" – 未知
  //    age // int 当前玩家年龄
  ;

  _proto.onInit = function onInit(param) {
    console.log("onInit:", "userId " + param.userId + " nickName " + param.nickName + " headUrl " + param.headUrl + " age " + param.age);
  } //退出游戏
  ;

  _proto.quit = function quit() {
    window["GameSDK"].quit(1);
  } //游戏调用该函数，拉起平台支付
  //   orderId: int 订单号
  //   goodsName: string 商品名称
  //   goodsDesc: string 商品描述
  //   orderAmount: int 订单金额
  //   extension： string 透传参数
  //   notifyURL: string 支付付款通知地址
  ;

  _proto.pay = function pay() {
    window["GameSDK"].pay(+new Date(), "钻石", "钻石恒久远，一颗永流传", 1, "支付", "支付付款通知地址");
  } //平台收到游戏pay函数后,拉起支付，支付结果通过该函数返回
  //    result,  // int 支付结果 0、成功，非0、错误号
  //    message   // string 描述
  ;

  _proto.onPay = function onPay(param) {
    console.log("onPay:", " result " + param.result + " message " + param.message);
  } //设置平台横屏
  ;

  _proto.setScreenLandescape = function setScreenLandescape() {
    window["GameSDK"].setOrientation(0);
  } //设置平台竖屏
  ;

  _proto.setScreenPortrait = function setScreenPortrait() {
    window["GameSDK"].setOrientation(1);
  } //平台进入前台，通过该函数通知游戏
  ;

  _proto.onResume = function onResume() {
    console.log("onResume:");
  } //平台进入后台，通过该函数通知游戏
  ;

  _proto.onPause = function onPause() {
    console.log("onPause:");
  } //平台通知游戏 开启关闭声音
  //    enable,  // int 是否开启 0、关，1、开
  //    volume   // int 音量 1 - 100
  ;

  _proto.onAudio = function onAudio(param) {
    console.log("onAudio:", " enable " + param.enable + " volume " + param.volume);
  } // 创建Banner广告 创建一次即可，自动刷新广告
  // 参数
  //   adId: string 广告序号ID 游戏自定义
  //   bannerAdId: string Banner广告ID 需后台申请
  //   position: int 广告位置 1 屏幕顶部 2 屏幕底部
  ;

  _proto.createBannerAd = function createBannerAd() {
    var _this = this;

    this._bannerLoadTimes = 1;
    this.bannerLoaded = false;
    this._banner = window["AdSDK"].createBannerAd("1", this._bannerId, 2); //注册onLoad函数,游戏调用创建banner时，AdSDK通知平台创建广告，当创建成功，会执行该回调函数通知游戏

    this._banner["onLoad"](function () {
      _this._bannerLoadTimes = 0;
      _this.bannerLoaded = true;
      AdEvent.I.handleEvent(E_ADEventType.banner_loadOver);
      console.log("this._banner 创建banner成功，可以调用展示");
    }); //注册onError函数,游戏调用创建banner时，AdSDK通知平台创建广告，当创建失败，会执行该回调函数通知游戏


    this._banner["onError"](function (param) {
      _this._bannerLoadTimes = 0;

      _this.destroyBannerAd();

      console.log("this._banner 创建banner失败，错误码 = ", param.errorCode);
    });

    console.log('this._banner 游戏创建banner广告');
  };

  _proto.showBannerAd = function showBannerAd() {
    if (this.bannerLoaded) {
      //Object.keys(this._banner).length &&
      this._banner["show()"].then(function () {
        console.log('this._banner 广告显示成功');
      }, function (err) {
        console.log('this._banner 广告显示失败');
      });

      console.log('this._banner 展示banner广告');
    } else {
      console.log('this._banner 未加载成功');
    }
  };

  _proto.hideBannerAd = function hideBannerAd() {
    this._banner["hide"]();

    console.log('this._banner 隐藏banner广告');
  };

  _proto.destroyBannerAd = function destroyBannerAd() {
    this.bannerLoaded = false;

    this._banner["destroy"]();

    console.log('this._banner 销毁banner广告');
  } // 创建插屏广告 展示一次调用一次创建
  // 参数
  //   adId: string 广告序号ID 游戏自定义
  //   interstitialAdId: string 插屏广告ID 需后台申请
  //   style: int 广告类型 1 全屏 2 半屏
  ;

  _proto.createInterstitialAd = function createInterstitialAd() {
    var _this2 = this;

    this._interstitialLoadTimes = 1;
    this._interstitialAd = window["AdSDK"].createInterstitialAd("1", this._interstitialId, 2); //注册onLoad函数,游戏调用创建插屏时，AdSDK通知平台创建广告，当创建成功，会执行该回调函数通知游戏

    this._interstitialAd["onLoad"](function () {
      _this2._interstitialLoadTimes = 0;
      _this2.interstitialAdLoaded = true;
      console.log("this._interstitialAd 创建插屏成功，可以调用展示");
    }); //注册onError函数,游戏调用创建插屏时，AdSDK通知平台创建广告，当创建失败，会执行该回调函数通知游戏


    this._interstitialAd["onError"](function (param) {
      _this2._interstitialLoadTimes = 0;
      console.log("this._interstitialAd 创建插屏失败，错误码 = ", param.errorCode);

      _this2.destroyInterstitialAd(); //加载广告失败，销毁


      AdEvent.I.handleEvent(E_ADEventType.interstitial_loadFail);
    });

    console.log("this._interstitialAd 游戏创建插屏广告");
  };

  _proto.showInterstitialAd = function showInterstitialAd() {
    var _this3 = this;

    if (this.interstitialAdLoaded) {
      this._interstitialAd["show"]().then(function () {
        console.log("this._interstitialAd 广告显示成功,可给与奖励");

        _this3.destroyInterstitialAd(); //展示成功后，销毁


        setTimeout(function () {
          _this3.createInterstitialAd();
        }, 100);
      }, function (err) {
        console.log("this._interstitialAd 广告显示失败");
        AdEvent.I.handleEvent(E_ADEventType.interstitial_showFail);
      });

      console.log("this._interstitialAd 游戏展示插屏广告");
    } else {
      console.log("this._interstitialAd 广告未加载成功");
    }
  };

  _proto.hideInterstitialAd = function hideInterstitialAd() {
    this._interstitialAd["hide"]();

    console.log("this._interstitialAd 游戏隐藏插屏广告");
  };

  _proto.destroyInterstitialAd = function destroyInterstitialAd() {
    this.interstitialAdLoaded = false;

    this._interstitialAd["destroy"]();

    console.log("this._interstitialAd 游戏销毁插屏广告");
  } // 创建激励视频广告 展示一次创建一次
  // 参数
  //   adId: string 广告序号ID 游戏自定义
  //   videoAdId: string 视频广告ID 需后台申请
  //   screenOrientation: int 广告类型 1 横屏 2 竖屏
  ;

  _proto.createRewardedVideoAd = function createRewardedVideoAd() {
    var _this4 = this;

    var that = this;
    this._videoLoadTimes = 1;
    this._videoAd = window["AdSDK"].createRewardedVideoAd("1", this._videoId, 1); //注册onLoad函数,游戏调用创建视频时，AdSDK通知平台创建广告，当创建成功，会执行该回调函数通知游戏

    this._videoAd["onLoad"](function () {
      _this4._videoLoadTimes = 0;
      _this4.videoAdLoaded = true;
      console.log("rewardedvideoAd 创建视频广告成功，可以调用展示");
    }); //注册onError函数,游戏调用创建视频时，AdSDK通知平台创建广告，当创建失败，会执行该回调函数通知游戏


    this._videoAd["onError"](function (param) {
      _this4._videoLoadTimes = 0;
      console.log("rewardedvideoAd 创建视频广告失败，错误码 = ", param.errorCode);

      _this4.destroyRewardedVideoAd(); //加载广告失败，销毁


      AdEvent.I.handleEvent(E_ADEventType.video_loadFail);
    }); //注册onClose函数,视频广告播放完整或主动退出观看视频时，展示落地页面，右上方关闭视频按钮触发，该函数执行。


    this._videoAd["onClose"](function () {
      console.log("rewardedvideoAd 视频广告关闭,回到游戏页面");

      if (!that._isVideoPlayed) {
        console.log("....................handle close...........");
        AdEvent.I.handleEvent(E_ADEventType.video_close);
      }

      setTimeout(function () {
        _this4.createRewardedVideoAd();
      }, 100);

      _this4.destroyRewardedVideoAd(); //视频广告关闭，销毁

    });

    console.log("rewardedvideoAd 游戏创建视频广告");
  };

  _proto.showRewardedVideoAd = function showRewardedVideoAd() {
    var that = this;

    if (this.videoAdLoaded) {
      this._videoAd["show"]().then(function () {
        console.log("rewardedvideoAd 广告显示成功，可以给与奖励");
        that._isVideoPlayed = true;
        AdEvent.I.handleEvent(E_ADEventType.video_showOver);
      }, function (err) {
        console.log("rewardedvideoAd 广告显示失败");
        AdEvent.I.handleEvent(E_ADEventType.video_showFail);
      });

      console.log("rewardedvideoAd 游戏展示视频广告");
    } else {
      console.log("rewardedvideoAd 视频广告未加载成功");
    }
  };

  _proto.destroyRewardedVideoAd = function destroyRewardedVideoAd() {
    this._isVideoPlayed = false;
    this.videoAdLoaded = false;

    this._videoAd["destroy"]();

    console.log("rewardedvideoAd 游戏销毁视频广告");
  };

  _createClass(AdCocos, null, [{
    key: "I",
    get: function get() {
      if (!AdCocos._I) {
        AdCocos._I = new AdCocos();
      }

      return AdCocos._I;
    } //国内=854584713  海外=673307600

  }]);

  return AdCocos;
}(), _defineProperty(_class2, "_I", null), _temp)) || _class;

export { AdCocos as default };

_cclegacy._RF.pop();